<template>
  <v-card :loading="loading">
    <div class="top-row">
      <h4>Folk i stimmet</h4>
    </div>
    <div ref="refContainer" class="icon-container" v-if="!loading && mergedIconPos">
      <div
        v-for="icon in mergedIconPos"
        :key="icon.name"
        class="icon"
        :style="`left:${icon.x}%;top:${icon.y}%`"
      >
        <img class="icon-image" :src="icon.src" :alt="icon.name" :class="icon.class" />
        <div class="icon-name">
          <div>
            {{ icon.name }} <span>{{ icon.userName }}</span>
          </div>
          <div>Sågs {{ icon.lastSeen }}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import 'moment/locale/sv'
import abborre from '@/assets/ikon_abborre.svg'
import havsborstmask from '@/assets/ikon_havsborstmask.svg'
import hummer from '@/assets/ikon_hummer.svg'
import manet from '@/assets/ikon_manet.svg'
import marla from '@/assets/ikon_marla.svg'
import mussla from '@/assets/ikon_mussla.svg'
import sal from '@/assets/ikon_sal.svg'
import sjostjarna from '@/assets/ikon_sjostjarna.svg'
import torsk from '@/assets/ikon_torsk.svg'
import tumlare from '@/assets/ikon_tumlare.svg'

moment.locale('sv')

export default {
  name: 'Stimmet',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      icons: [
        { src: abborre, name: 'Abborren' },
        { src: havsborstmask, name: 'Havsborstmasken' },
        { src: hummer, name: 'Hummern' },
        { src: manet, name: 'Maneten' },
        { src: marla, name: 'Märlan' },
        { src: mussla, name: 'Musslan' },
        { src: sal, name: 'Sälen' },
        { src: sjostjarna, name: 'Sjöstjärnan' },
        { src: torsk, name: 'Torsken' },
        { src: tumlare, name: 'Tumlaren' },
      ],
      positions: [
        { x: 5, y: 5 },
        { x: 32, y: 60 },
        { x: 2, y: 30 },
        { x: 52, y: 15 },
        { x: 39, y: 37 },
        { x: 6, y: 78 },
        { x: 62, y: -6 },
        { x: 57, y: 80 },
        { x: 63, y: 50 },
        { x: 0, y: 50 },
      ],
      flips: [...Array(5).fill({ class: 'flip' }), ...Array(5).fill({ class: '' })],
    }
  },
  computed: {
    ...mapGetters('user', { getAdmins: 'getArray' }),
    admins() {
      return [...this.getAdmins]
        .map((a) => {
          return {
            ...a,
            userName: a.admin_name.split(' ')[0],
            lastSeen: a.admin_last_seen ? moment(a.admin_last_seen).fromNow() : null,
          }
        })
        .filter((a) => a.lastSeen)
        .sort((a, b) => b.lastSeen.localeCompare(a.lastSeen))

        .slice(0, 10)
    },
    mergedIconPos() {
      const randomIcons = [...this.icons].sort(() => Math.random() - 0.5)
      const randomPos = [...this.positions].sort(() => Math.random() - 0.5)
      const randomPosAdmins = [...this.admins].sort(() => Math.random() - 0.5)
      const randomPosFlips = [...this.flips].sort(() => Math.random() - 0.5)
      return randomIcons.map((icon) => ({
        ...icon,
        ...randomPos.pop(),
        ...randomPosAdmins.pop(),
        ...randomPosFlips.pop(),
      }))
    },
  },
}
</script>

<style lang="less" scoped>
.flip {
  transform: scaleX(-1);
}
.top-row {
  padding-left: 15px;
  padding-top: 12px;
}
.icon-container {
  position: relative;
  padding: 0 15px 15px 15px;
  font-size: 12px;
  height: 270px;
  .icon {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 4px;
    .icon-image {
      width: 50px;
    }
    .icon-name {
      display: flex;
      flex-direction: column;
      white-space: nowrap;
      span {
        font-weight: 500;
      }
    }
  }
}
</style>
